import React from 'react';
import PropTypes from 'prop-types';

export default function EditIcon(props) {
  const { fill, size } = props;

  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 20 20'>
      <path fill='none' d='M0 0h20v20H0z' data-name='Retângulo 148014' />
      <path
        fill={fill}
        fillRule='evenodd'
        d='M11.805 4.774a1.208 1.208 0 0 0-1.709 0l-.423.425-5.982 5.986-.188.189s-.6.6-1.958 4.983l-.029.092-.073.239-.066.218-.056.186c-.043.143-.087.289-.131.44-.1.331-.336 1.076-.066 1.346s1.013.031 1.343-.067l.438-.128.194-.059.205-.063.251-.077.073-.023c4.169-1.297 4.917-1.906 4.977-1.962l.2-.2.013.013 5.987-5.982.427-.427a1.209 1.209 0 0 0 0-1.71ZM7.924 15.722l-.019.013-.014.009-.016.01-.016.01a13.846 13.846 0 0 1-2.2.939c-.166.06-.346.123-.535.189l-2.019-2.016c.066-.19.129-.372.189-.539a13.849 13.849 0 0 1 .937-2.206l.008-.013.012-.019.008-.013.013-.02.147-.148 3.656 3.653ZM18.646 4.774l-3.419-3.42a1.208 1.208 0 0 0-1.709 0l-.854.855a1.209 1.209 0 0 0 0 1.71l3.418 3.419a1.208 1.208 0 0 0 1.709 0l.855-.855a1.209 1.209 0 0 0 0-1.709Z'
        data-name='Caminho 462'
      />
    </svg>
  );
}

EditIcon.defaultProps = {
  size: '20',
  fill: '#4b4b4b'
};

EditIcon.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.string
};
